import { render } from "./EditarPerfilView.vue?vue&type=template&id=8239ea68&scoped=true"
import script from "./EditarPerfilView.vue?vue&type=script&scoped=true&lang=js"
export * from "./EditarPerfilView.vue?vue&type=script&scoped=true&lang=js"

import "./EditarPerfilView.vue?vue&type=style&index=0&id=8239ea68&scoped=true&lang=css"

import exportComponent from "/var/www/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8239ea68"]])

export default __exports__